import styled, { css } from 'styled-components';
import { maxWidth } from '@/assets/styles/mixins.css.js';
import vars from '@/assets/styles/vars';

const Container = styled.div`
  min-width: ${vars.container.minWidth}px;
  width: calc(100% - ${vars.container.spaceDesktop}px * 2);
  max-width: ${vars.container.maxWidth}px;
  margin-left: auto;
  margin-right: auto;

  ${maxWidth(vars.breakpoints.tablet)`
    width: calc(100% - ${vars.container.spaceTablet}px * 2);
  `}

  ${maxWidth(vars.breakpoints.mobile)`
    width: calc(100% - ${vars.container.spaceMobile}px * 2);
  `}

   ${(props) =>
    props.fullWidth &&
    css`
      width: 100%;
      max-width:unset;
    `}
`;

export default Container;
